// What the admin panel shows, in the order it shows it: Players, Games, Songs, Daily Gig, Challenges, then System (the
// tables the game keeps to run: rooms' keys, tickets, links, caches, the event log, accounts). The backend discovers
// each file here on its own; this list is for the admin's build.
import playersCollection from "./players";
import reportsCollection from "./reports";
import blocksCollection from "./blocks";
import gamesCollection from "./games";
import roomsCollection from "./rooms";
import songsCollection from "./songs";
import gameSongsCollection from "./game-songs";
import dailyScoresCollection from "./daily-scores";
import challengesCollection from "./challenges";
import challengeScoresCollection from "./challenge-scores";
import gamePlayersCollection from "./game-players";
import dailyAttemptsCollection from "./daily-attempts";
import challengeAttemptsCollection from "./challenge-attempts";
import soloSavesCollection from "./solo-saves";
import friendProfilesCollection from "./friend-profiles";
import friendshipsCollection from "./friendships";
import friendRequestsCollection from "./friend-requests";
import friendLinksCollection from "./friend-links";
import gameInvitesCollection from "./game-invites";
import pushSubscriptionsCollection from "./push-subscriptions";
import catalogueFilesCollection from "./catalogue-files";
import aiSpendCollection from "./ai-spend";
import voiceCacheCollection from "./voice-cache";
import eventsCollection from "./events";
import usersCollection from "./users";

export const collections = [
    playersCollection,
    reportsCollection,
    blocksCollection,
    gamesCollection,
    roomsCollection,
    songsCollection,
    gameSongsCollection,
    dailyScoresCollection,
    challengesCollection,
    challengeScoresCollection,
    gamePlayersCollection,
    dailyAttemptsCollection,
    challengeAttemptsCollection,
    soloSavesCollection,
    friendProfilesCollection,
    friendshipsCollection,
    friendRequestsCollection,
    friendLinksCollection,
    gameInvitesCollection,
    pushSubscriptionsCollection,
    catalogueFilesCollection,
    aiSpendCollection,
    voiceCacheCollection,
    eventsCollection,
    usersCollection,
];
